var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"loader-outer"},[_c('div',{staticClass:"loader"},[_c('span',{staticClass:"dot dot-1"}),_c('span',{staticClass:"dot dot-2"}),_c('span',{staticClass:"dot dot-3"}),_c('span',{staticClass:"dot dot-4"})])])])
}]

export { render, staticRenderFns }